export const CHECKOUT_URL =
  'https://clinical-lab-visual-atlas.impultienda.ar/checkout'
export const PURCHASE_ANCHOR = '#comprar'

export const BOX_IMAGE =
  'https://cdn.magicpatterns.com/uploads/7GTsZDkczazhc4uLcddtGP/Diseno_sin_titulo-6.webp'

export const insideImages: { src: string; caption: string }[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/q7LvZrRHwzFh8TvXN9UtZL/Captura_de_pantalla_2026-09-11_a_la(s)_6.51.34_p._m..png',
    caption: 'RBC Count, Hemoglobin & Hematocrit',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/87XZxeC6qLvk3zcwg3dC1J/Captura_de_pantalla_2026-09-11_a_la(s)_6.51.57_p._m..png',
    caption: 'RBC Indices: Complete Connection Map',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/gV3yeWsk57M5gQ99VNkAXS/Captura_de_pantalla_2026-09-11_a_la(s)_6.52.16_p._m..png',
    caption: 'RBC Arrangement: Rouleaux vs Agglutination',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/5fMsbR2QtxjDJis2xP5eD8/Captura_de_pantalla_2026-09-11_a_la(s)_6.52.39_p._m..png',
    caption: 'Monocytes, Eosinophils & Basophils',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/bvHhdhuswzEBv5nStZeTtU/Captura_de_pantalla_2026-09-11_a_la(s)_6.54.11_p._m..png',
    caption: 'Hemostasis: From Vessel Injury to Fibrin',
  },
]

export const systemChecklist = [
  'CBC & morphology references',
  'Clinical chemistry correlations',
  'Microbiology visual patterns',
  'Immunology & serology maps',
  'Urinalysis & body fluid references',
  'Blood bank visual resources',
  'Integrated laboratory patterns',
  'Professional references ready to use',
]

export interface Module {
  number: number
  title: string
  body: string
  steps: string
}

export const modules: Module[] = [
  {
    number: 1,
    title: 'VISUAL HEMATOLOGY & HEMOSTASIS ATLAS™',
    body: 'Review hematology with organized visual references, morphology patterns, comparisons and laboratory correlations. Explore CBC relationships, red and white cell morphology, platelet findings, analyzer concepts and hemostasis clearly. Compare important hematology appearances without rebuilding your reference system every time. Use the atlas alongside appropriate laboratory procedures and professional references.',
    steps: 'Observe. Compare. Correlate.',
  },
  {
    number: 2,
    title: 'CLINICAL CHEMISTRY PATTERN ATLAS™',
    body: 'Review clinical chemistry results with structured visual references, correlations and organized pattern maps. Explore renal, liver-related, electrolyte, glucose, acid-base, lipid and protein laboratory relationships. Use organized resources instead of studying disconnected chemistry values every day. Interpret them alongside appropriate laboratory context and professional references.',
    steps: 'Connect. Compare. Recognize.',
  },
  {
    number: 3,
    title: 'CLINICAL MICROBIOLOGY VISUAL ATLAS™',
    body: 'Keep microbiology morphology, specimen concepts and laboratory identification patterns organized in one clear system. Use visual references for Gram appearances, organism morphology, culture observations and identification principles. Review relevant patterns without relying on scattered images or isolated references. Use appropriate laboratory procedures and professional guidance as your reference.',
    steps: 'Observe. Identify. Compare.',
  },
  {
    number: 4,
    title: 'IMMUNOLOGY & SEROLOGY VISUAL ATLAS™',
    body: 'Review immune-system relationships, antibodies, serological patterns and immunoassay concepts visually. Keep antigen-antibody relationships, serology concepts and test-performance information together. Use structured references alongside appropriate laboratory evaluation and testing information. Understand what matters without rebuilding your reference system every day.',
    steps: 'Connect. Compare. Correlate.',
  },
  {
    number: 5,
    title: 'URINALYSIS & BODY FLUIDS VISUAL ATLAS™',
    body: 'Keep urinalysis findings and body-fluid visual references structured and easier to review. Use chemical findings, cells, casts, crystals and microscopic comparison references. Organize physical, chemical and microscopic findings into clear visual relationships. Review what you see without searching for the same references from scratch.',
    steps: 'Inspect. Observe. Compare.',
  },
  {
    number: 6,
    title: 'BLOOD BANK & INTEGRATED LAB PATTERNS™',
    body: 'Organize the information that needs to connect across blood bank and different laboratory disciplines. Use structured ABO, Rh, antibody, compatibility and integrated laboratory comparison resources. Keep specimen quality, laboratory findings, correlations and important limitations clear. Build an organized overview of the complete laboratory pattern.',
    steps: 'Connect. Integrate. Verify.',
  },
]

export interface Bonus {
  number: number
  title: string
  subtitle: string
  body: string
  steps: string
}

export const bonuses: Bonus[] = [
  {
    number: 1,
    title: 'LAB RESULTS QUICK REFERENCE™',
    subtitle: 'The Visual Laboratory Reference Companion',
    body: 'Review commonly encountered laboratory parameters, related findings and important correlations in one place. Use organized visual cards, comparison grids and quick-reference maps whenever you need them. Keep essential laboratory information easier to find and review.',
    steps: 'Check. Connect. Reference.',
  },
  {
    number: 2,
    title: 'SPECIMEN QUALITY & LAB ERROR VISUAL GUIDE™',
    subtitle: 'Pre-Analytical, Analytical & Post-Analytical Reference',
    body: 'Review specimen quality, common laboratory error concepts, interference and testing-process considerations. Use visual workflows to understand pre-analytical, analytical and post-analytical issues. Keep important quality considerations organized before reviewing each result.',
    steps: 'Inspect. Check. Verify.',
  },
  {
    number: 3,
    title: 'CLINICAL LAB PATTERN CASEBOOK™',
    subtitle: 'Visual Correlation Cases for Laboratory Professionals',
    body: 'Practice connecting laboratory findings through fictional educational cases and structured pattern maps. Use result panels, correlations and visual reasoning exercises across different laboratory areas. Keep active laboratory pattern-recognition practice organized in one practical resource.',
    steps: 'Observe. Connect. Practice.',
  },
  {
    number: 4,
    title: 'MICROSCOPY RECOGNITION GUIDE™',
    subtitle: 'Visual Identification & Comparison Companion',
    body: 'Compare blood-cell morphology, urine sediment, casts, crystals and common microscopic look-alikes. Use structured visual comparisons to recognize important distinguishing characteristics. Stop searching for disconnected microscopy references from scratch.',
    steps: 'Observe. Compare. Differentiate.',
  },
  {
    number: 5,
    title: 'LAB VERIFICATION & QUALITY CHECKLIST SYSTEM™',
    subtitle: 'Practical Visual Workflow Companion',
    body: 'Review specimen, result, correlation, interference and verification considerations with organized checklists. Use ready-to-review workflows, quality maps and structured verification resources. Keep important laboratory review information clearly organized and easy to access.',
    steps: 'Check. Correlate. Verify.',
  },
]

export const differentiators = [
  {
    emoji: '🧪',
    title: 'Ready-to-use professional visual resources',
    body: 'Open the system and access organized references instead of searching for everything from scratch.',
  },
  {
    emoji: '🔬',
    title: 'Practical laboratory pattern review',
    body: 'Use atlases, comparisons, diagrams and reference guides to review laboratory science.',
  },
  {
    emoji: '🧩',
    title: '6 essential areas in one system',
    body: 'Keep hematology, chemistry, microbiology, immunology, urinalysis and blood bank organized.',
  },
  {
    emoji: '🔄',
    title: 'Reusable visual resources',
    body: 'Return to the atlases, comparisons and reference guides whenever you need them.',
  },
  {
    emoji: '📂',
    title: 'Everything in one organized place',
    body: 'Stop relying on scattered values, images, references and disconnected study materials.',
  },
  {
    emoji: '⏱️',
    title: 'Less repetitive searching',
    body: 'Spend less time finding the same laboratory visual references every day.',
  },
]

export const offerChecklist = [
  '6 professional modules',
  '5 professional bonuses',
  'Hematology & morphology atlas',
  'Clinical chemistry patterns',
  'Microbiology visual references',
  'Immunology & serology maps',
  'Urinalysis & body fluid atlas',
  'Blood bank & integration tools',
]

export interface Testimonial {
  name: string
  role: string
  location: string
  quote: string
}

export const testimonials: Testimonial[] = [
  {
    name: 'Hannah Whitmore, 31',
    role: 'Medical Laboratory Scientist · Hematology bench',
    location: 'Leeds, United Kingdom',
    quote:
      'On night shifts I used to keep three textbooks and a folder of saved images open just to confirm a morphology call. Now I open the hematology atlas, compare the annotated pattern and move on. The rouleaux versus agglutination comparison alone has changed how confidently I review analyzer flags.',
  },
  {
    name: 'Daniel Okonkwo, 38',
    role: 'Clinical Laboratory Scientist · Core lab generalist',
    location: 'Toronto, Canada',
    quote:
      'Rotating between chemistry, urinalysis and blood bank meant constantly relearning how findings connect. Having all six areas built with the same visual structure made the correlations obvious. The specimen quality and lab error guide is now part of how I train new staff.',
  },
  {
    name: 'Marissa Delgado, 26',
    role: 'Clinical Laboratory Science student · Final year',
    location: 'San Antonio, United States',
    quote:
      'I was studying CBC values and morphology as two separate subjects and it never clicked. The RBC indices connection map was the turning point — seeing the numerical pattern and the predicted morphology side by side is exactly how I needed it explained. My board review went far better than expected.',
  },
  {
    name: 'Priya Raghunathan, 34',
    role: 'Laboratory Technologist · Microbiology & immunology',
    location: 'Melbourne, Australia',
    quote:
      'The microbiology and serology atlases are what I reach for weekly. Gram appearances, organism morphology and antigen-antibody relationships in one organized place stopped me from hunting through scattered references before every review.',
  },
  {
    name: 'Alan Gillespie, 47',
    role: 'Laboratory Technician · Transfusion services',
    location: 'Glasgow, United Kingdom',
    quote:
      'What I appreciate is how organized it is. Six areas, the same structure in each, everything annotated. I use the blood bank and integration module before shifts and the verification checklist system to keep my review consistent under pressure.',
  },
]

export interface Faq {
  q: string
  a: string
}

export const faqs: Faq[] = [
  {
    q: 'Is this a physical product?',
    a: 'No. CLINICAL LAB VISUAL ATLAS™ is a 100% digital professional resource.',
  },
  {
    q: 'Who is this system for?',
    a: 'Medical Laboratory Scientists, Clinical Laboratory Scientists, laboratory technologists, laboratory technicians and advanced clinical laboratory science students looking for organized visual resources.',
  },
  {
    q: 'Is this clinical laboratory training or a certification?',
    a: 'No. It is a visual learning and reference system, not a certification or replacement for required professional training.',
  },
  {
    q: 'Is this another ebook filled with theory?',
    a: 'No. The system focuses on visual atlases, morphology, comparisons, laboratory patterns, correlation maps and ready-to-review resources.',
  },
  {
    q: 'Do I have to create the resources myself?',
    a: 'No. The resources are already created and organized. Choose the appropriate atlas and use it according to your educational needs and professional responsibilities.',
  },
  {
    q: 'What areas are included?',
    a: 'Hematology & Hemostasis, Clinical Chemistry, Clinical Microbiology, Immunology & Serology, Urinalysis & Body Fluids, and Blood Bank & Integrated Lab Patterns.',
  },
  {
    q: 'Can I use the resources in different study situations?',
    a: 'Yes. The visual resources can be used according to your learning needs, professional context and appropriate laboratory references.',
  },
  {
    q: 'Are the resources ready to use?',
    a: 'Yes. They are designed for practical digital reference and visual clinical laboratory study.',
  },
  {
    q: 'What additional resources are included?',
    a: 'Five bonuses covering quick-reference laboratory results, specimen quality and errors, pattern cases, microscopy recognition, and verification and quality checklists.',
  },
  {
    q: 'Does this replace laboratory procedures or professional judgment?',
    a: 'No. CLINICAL LAB VISUAL ATLAS™ does not replace professional training, laboratory procedures, validated methods, professional judgment, supervision or appropriate clinical evaluation.',
  },
  {
    q: 'How will I receive the product?',
    a: 'You’ll receive immediate digital access after your purchase.',
  },
]

export const purchaseNotifications = [
  { name: 'Emma Whitfield', city: 'Manchester', country: 'United Kingdom' },
  { name: 'Sarah Collins', city: 'Toronto', country: 'Canada' },
  { name: 'Michelle Brennan', city: 'Melbourne', country: 'Australia' },
  { name: 'Linda Carter', city: 'Columbus', country: 'United States' },
  { name: 'Joanne Mackay', city: 'Glasgow', country: 'United Kingdom' },
  { name: 'Rachel Dumont', city: 'Ottawa', country: 'Canada' },
  { name: 'Teresa Novak', city: 'San Antonio', country: 'United States' },
  { name: 'Katrina Boyle', city: 'Brisbane', country: 'Australia' },
  { name: 'Deborah Fields', city: 'Leeds', country: 'United Kingdom' },
  { name: 'Nicole Tremblay', city: 'Calgary', country: 'Canada' },
  { name: 'Angela Ruiz', city: 'Tampa', country: 'United States' },
  { name: 'Fiona Pearce', city: 'Perth', country: 'Australia' },
]
